import * as React from 'react';
import { useState } from 'react';
import { Field, Form } from 'formik';
import * as Yup from 'yup';

import FormikForm from '~/lib/forms/FormikForm';
import Input from '~/common/controls/Input';
import Select from '~/common/controls/Select';

import { UserRole } from '../../consts';


const ROLE_OPTIONS = [
  {
    label: 'Clerk',
    value: UserRole.CLERK,
  },
  {
    label: 'Agent',
    value: UserRole.AGENT,
  }
];

const UserSchema = Yup.object().shape({
  username: Yup.string()
    .required('Required'),
  role: Yup.string(),
  // locationId: Yup.string().required('Required'),
  firstName: Yup.string().required('Required'),
  lastName: Yup.string().required('Required'),
});


const UserUpdateForm = (props) => {
  const { error, initialValues, onSubmit, locations } = props;
  const isChecked = initialValues && initialValues.hasOwnProperty('forcePasswordChange') ? initialValues.forcePasswordChange : true;
  const [forcePassword, serForcePassword] = useState(isChecked);

  const cbChange = (field, check) => {
    serForcePassword(!forcePassword);
  };

  return (
    <FormikForm
      enableReinitialize={true}
      initialValues={initialValues}
      onSubmit={(data) => onSubmit(UserSchema.cast(data))}
      validationSchema={UserSchema}
      render={(props) => {
        return (
          <Form className="form__cont">
            <Field
              name="role"
              label="Role"
              component={Select}
              options={ROLE_OPTIONS}
              className="input input--bubble"
            />
            <Field
              name="locationId"
              label="Location"
              component={Select}
              options={locations}
              className="input input--bubble"
            />
            <Field
              name="firstName"
              label="First Name"
              type="text"
              component={Input}
              className="input input--bubble"
            />
            <Field
              name="lastName"
              label="Last Name"
              type="text"
              component={Input}
              className="input input--bubble"
            />
            <div className="input--checkbox--inline">
              <Field
                name="forcePasswordChange"
                label="Force password change"
                className="input--checkbox"
                type="checkbox"
                cbChange={cbChange}
                checked={forcePassword}
                component={Input}
              />
            </div>

            {error && <div className="form__note">{error}</div>}

            <button className="btn btn--prim btn--lg" type="submit">
              Submit
            </button>
          </Form>
        );
      }}
    />
  );
};

export default UserUpdateForm;
